import React from "react";
import classNames from "classnames";
import { Icon } from "./Icon";
export const Checkbox = (props) => {
    return (React.createElement("div", { className: classNames("checkbox", props.cssWrapper) },
        React.createElement("input", { type: "checkbox", name: props.name, value: "1", defaultChecked: props.defaultChecked, className: "checkbox-input", ref: props.innerRef, id: props.id }),
        React.createElement("span", { className: "checkbox-ui" },
            React.createElement(Icon, { c: ['tick', 12, 12] })),
        React.createElement("label", { className: "checkbox-description", htmlFor: props.id }, props.children),
        props.error && React.createElement("span", { className: "inline-error" }, props.error)));
};
